/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateObjectDto } from '../../models/create-object-dto';
import { ObjectResDto } from '../../models/object-res-dto';

export interface StorageControllerCreateObjectsBulk$Params {
  body: Array<CreateObjectDto>;
}

export function storageControllerCreateObjectsBulk(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerCreateObjectsBulk$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<ObjectResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerCreateObjectsBulk.PATH,
    'put',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ObjectResDto>>;
      }),
    );
}

storageControllerCreateObjectsBulk.PATH = '/storage/object/bulk';
